// extracted by mini-css-extract-plugin
module.exports = {"headline":"contact_headline__bre9J","content":"contact_content__by9c_","container":"contact_container__17Cye"};